/**
 * toggle construction modal configs
 * @param node filter
 */
const filterConstructionModals = filter => {
  const modal = filter.dataset.modal
  const pieces = filter.dataset.pieces
  document.querySelectorAll('.construction-modal-config-vign').forEach(vign => {
    if (pieces !== 'all') {
      if (vign.dataset.pieces !== pieces && vign.dataset.modal !== modal) {
        vign.classList.add('is-hidden')
      } else {
        vign.classList.remove('is-hidden')
      }
    } else if (pieces === 'all') {
      vign.classList.remove('is-hidden')
    }
  })
}

export const removeActiveClassFromOtherFilters = () => {
  document.querySelectorAll('.piece-filter').forEach(filter => {
    filter.classList.remove('is-active')
  })
}

/**
 * On filter by solution: show hide pieces filter if no config with the given pieces
 * @param strinig piecesArray
 */
const togglePiecesFilters = piecesArray => {
  document.querySelectorAll('.piece-filter').forEach(filter => {
    if (piecesArray.length) {
      if (piecesArray.indexOf(filter.dataset.pieces) < 0) {
        filter.classList.add('is-hidden')
      }
    } else {
      filter.classList.remove('is-hidden')
    }
  })
}

/**
 * Remive is-active class form active solution
 */
export const removeActiveClassFromOtherSolutions = () => {
  document.querySelectorAll('.is-solution').forEach(filter => {
    filter.classList.remove('is-active')
  })
}

/**
 * Filter construction modals
 */
export const ConstructionModalFilter = () => {
  document.addEventListener('click', e => {
    if (e.target.classList.contains('piece-filter') || e.target.parentElement.classList.contains('piece-filter')) {
      e.preventDefault()
      const target = e.target.classList.contains('piece-filter') ? e.target : e.target.parentElement
      if (!target.classList.contains('is-active')) {
        removeActiveClassFromOtherFilters()
        target.classList.add('is-active')
        filterConstructionModals(target)
      }
    }
  })
}

/**
 * Filter construction modal config by solution
 * @param string solution
 */
export const ConstructionModalFilterBySolution = solution => {
  const pieces = []
  document.querySelectorAll('.construction-modal-config-vign').forEach(vign => {
    if (solution !== 'all') {
      if (vign.dataset.offerline !== solution) {
        vign.classList.add('is-hidden')
      } else {
        vign.classList.remove('is-hidden')
        if (pieces.indexOf(vign.dataset.pieces) < 0) {
          pieces.push(vign.dataset.pieces)
        }
      }
    } else if (solution === 'all') {
      vign.classList.remove('is-hidden')
    }
  })
  togglePiecesFilters(pieces)
}
